"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputForm = exports.useInputFormChange = exports.useInputValue = void 0;
const react_1 = require("react");
const object_path_1 = __importDefault(require("object-path"));
const FormContext_1 = require("../contexts/FormContext");
const inputs_1 = require("../lib/inputs");
function useInputValue(props) {
    var _a, _b;
    const { formData } = react_1.useContext(FormContext_1.FormContext);
    return (_b = (_a = props.value) !== null && _a !== void 0 ? _a : (props.name && object_path_1.default.get(formData, props.name))) !== null && _b !== void 0 ? _b : '';
}
exports.useInputValue = useInputValue;
function useInputFormChange(props) {
    const { onChange: onChangeFromProps } = props;
    const { formData, setFormData, inForm } = react_1.useContext(FormContext_1.FormContext);
    return react_1.useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        const resp = yield (onChangeFromProps === null || onChangeFromProps === void 0 ? void 0 : onChangeFromProps(e));
        // using form
        if (e.target.name && inForm && resp !== false) {
            setFormData(yield inputs_1.createFormStateUpdaterFromEvent(props, e, formData), e);
        }
    }), [inForm, onChangeFromProps, setFormData, props, formData]);
}
exports.useInputFormChange = useInputFormChange;
function useInputForm(props) {
    const inputValue = useInputValue(props);
    const onInputChange = useInputFormChange(props);
    /*
    * Local value fixes the cursor position resetting upon a change.
    * https://stackoverflow.com/a/72263241
    */
    const [localValue, setLocalValue] = react_1.useState(inputValue);
    react_1.useEffect(() => {
        setLocalValue(inputValue);
    }, [inputValue]);
    const onChangeHandle = react_1.useCallback((e) => {
        /* onChange toggleInput is nested since it uses Checkbox which also uses withInput, this solves nesting. */
        if (e.isPropagationStopped && e.isPropagationStopped()) {
            return;
        }
        const rawInputValue = e.target.value;
        if (e.target.type !== 'file') {
            e.target.value = rawInputValue;
        }
        setLocalValue(e.target.value);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(e);
    }, [onInputChange]);
    let value = localValue;
    /* file inputs cant have a value programmatically set. */
    if (props.type === 'file') {
        value = undefined;
    }
    return {
        value,
        onChange: onChangeHandle,
    };
}
exports.useInputForm = useInputForm;
